export default __webpack_public_path__ + "static/media/card_green.24d5fd39.svg";